// extracted by mini-css-extract-plugin
export default {"modal":"IP-z","error":"JP-z","disabled":"KP-z","fields":"LP-z","errorMsg":"MP-z","footer":"NP-z","formContentWrapper":"OP-z","productImage":"PP-z","overlay":"QP-z"};